import { call, select } from "redux-saga/effects";
import { selectAuthenticationToken } from "Store/Selectors/Authentication";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function* callWithAuth(fn: (...args: any[]) => any, ...params: any[]) {
  const token = yield select(selectAuthenticationToken);
  const result = yield call(fn, token, ...params);
  return result;
}
